/* La web no tiene reproductor nativo (es cosa de la app de Android): mismas funciones que en la app, siempre «no hay». */

export const nativeBridge = () => null;
export const nativePlayerOn = () => false;
export const nativePreviewCore = () => null;

/** Rectángulo de un elemento en píxeles físicos (lo que entendería el plugin). */
export function physicalRect(el) {
    const r = el.getBoundingClientRect();
    const k = window.devicePixelRatio || 1;
    return [Math.round(r.left * k), Math.round(r.top * k), Math.max(1, Math.round(r.width * k)), Math.max(1, Math.round(r.height * k))];
}
